import React, { useContext, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./homePageCarousel.scss";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import DialogBox from "../ProfileLanding/Resources/DialogBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import { getNonLouielogic } from "../louie/NonLouielogic/NonLouielogicSlice";
import jwt_decode from "jwt-decode";
import AuthContext from "../shared-components/authContext";
import { getBannerData, selectBannerData } from "./getBannersSlice";
import { isTokenExpired } from "../../../utils/msal-utils";
import { GetBanner } from "./CarouselIndex";

export function HomePageCarousel(props: any) {
  const dispatch = useDispatch();
  const { NonLouielogicflag } = useSelector(getNonLouielogic);
  const carouselTitles: any = [];
  props?.isBirthDay && carouselTitles.push("Birthday Wishes");
  props?.isAnniDay && carouselTitles.push("Happy Anniversary");
  //props?.classRosterAndRequestId?.ClassRosterId  && carouselTitles.push("My Schedule");
  const [oracleId, setOracleId] = useState("0");
  const [visible, setVisible] = useState(false);
  const [playBtnVisibility, setPlayBtnVisibility] = useState(true);
  const { nonSSOlogout } = useContext(AuthContext);

  const { getBannerDataState, getData } = useSelector(selectBannerData);
  useEffect(() => {
    if (getBannerDataState === "fulfilled") {
      //console.log("Fetched Data:", getData);
    }
  }, [getData, getBannerDataState]);

  const sliderContainer = useRef<any>(null);

  const sliderHeightValue = sliderContainer?.current?.innerSlider?.list
    ?.getAttribute("style")
    ?.split("height:")[1]
    ?.split("px")[0];

  const [sliderHeight, setSliderHeight] = useState(sliderHeightValue);

  const footerContent = (
    <div>
      <Button label="OK" onClick={() => setVisible(false)} autoFocus />
    </div>
  );

  const updateSliderHeight = () => {
    const sliderHeightValue = sliderContainer?.current?.innerSlider?.list
      ?.getAttribute("style")
      ?.split("height:")[1]
      ?.split("px")[0];
    setSliderHeight(sliderHeightValue);
  };

  useEffect(() => {
    window.addEventListener("resize", updateSliderHeight);
    const interval = setInterval(() => {
      updateSliderHeight();
    }, 5000);
    return () => {
      window.removeEventListener("resize", updateSliderHeight);
      clearInterval(interval);
    };
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    appendDots: function (dots: any) {
      return (
        <div
          style={{
            padding: "10px",
            position: "relative",
            /*height: "378px", */
            height: sliderHeight + "px",
            minHeight: sliderHeight + "px",
            overflow: "auto",
            backgroundColor: "#8fd0ff",
          }}
        >
          <ul style={{ margin: "0px", paddingLeft: "0px" }}> {dots} </ul>
        </div>
      );
    },
    customPaging: function (i: any) {
      return <div className="btn7">{carouselTitles[i]}</div>;
    },
  };

  const onHide = (name: any) => {
    props.dialogFuncMap[`${name}`](false);
  };

  useEffect(() => {
    setSliderHeight(sliderHeightValue);
  }, [sliderHeightValue]);

  const playSlider = () => {
    sliderContainer?.current?.slickPlay();
    setPlayBtnVisibility(true);
  };

  const pauseSlider = () => {
    sliderContainer?.current?.slickPause();
    setPlayBtnVisibility(false);
  };
  let countryName = props?.profileData?.automation?.employee?.location_country;
  // console.log(props?.classRosterAndRequestId?.ClassRosterId)
  let jobFamily = props?.profileData?.automation?.employee?.job_family;
  const [isSSOLogin, setIsSSOLogin] = useState(false);
  useEffect(() => {
    const SSOToken = localStorage.getItem("AccessToken");
    const nonSSOToken = localStorage.getItem("AccessToken-NonSSO");
    let id: any;
    if (nonSSOToken && isTokenExpired(nonSSOToken)) {
      nonSSOlogout();
    }
    if (SSOToken) {
      id = localStorage.getItem("oracleId");
      setIsSSOLogin(true);
    }
    if (nonSSOToken) {
      const decodedToken: any = jwt_decode(nonSSOToken);
      id = decodedToken?.oracleID;
    }
    setOracleId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("oracleId"), localStorage.getItem("email")]);

  useEffect(() => {
    if (
      oracleId !== null &&
      oracleId !== undefined &&
      oracleId !== "0" &&
      countryName !== null &&
      countryName !== undefined &&
      countryName !== "" &&
      jobFamily !== null &&
      jobFamily !== undefined &&
      jobFamily !== ""
    ) {
      const data = {
        action: "getResourceLinks",
        oracleId: oracleId,
        country: countryName,
        flag: "topBanners",
        jobFamily: jobFamily,
        is_sso: isSSOLogin,
      };
      dispatch<any>(getBannerData(data));
    }
  }, [dispatch, oracleId, countryName, jobFamily, isSSOLogin]);

  return (
    <>
      <Slider {...settings} ref={sliderContainer}>
        {getData &&
          getData.length > 0 &&
          getData.map((item: any, key: number) => {
            if (
              item?.subfeature === "My Louie Tasks" &&
              NonLouielogicflag !== "false"
            ) {
              return null;
            }

            // Skip "My Schedule" if roster ID is not allowed
            if (
              item?.subfeature === "My Schedule" &&
              !(
                props?.classRosterAndRequestId?.ClassRosterId === "14685" ||
                props?.classRosterAndRequestId?.ClassRosterId === "14686" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15555" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15556" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15557" ||
                props?.classRosterAndRequestId?.ClassRosterId === "18700" ||
                props?.classRosterAndRequestId?.ClassRosterId === "18822" ||
                props?.classRosterAndRequestId?.ClassRosterId === "17104" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20126" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15940" ||
                 props?.classRosterAndRequestId?.ClassRosterId === "145" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20132" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20161" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20217" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20218" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20851" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20850" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20852" 
              )
            ) {
              return null;
            }

            // Push carousel title if conditions are valid
            if (
              item?.subfeature === "My Louie Tasks" &&
              NonLouielogicflag === "false"
            ) {
              if (!carouselTitles.includes("My Louie Tasks")) {
                carouselTitles.push("My Louie Tasks");
              }
            }

            if (item?.subfeature === "Birthday Wishes" && props?.isBirthDay) {
              if (!carouselTitles.includes("Birthday Wishes")) {
                carouselTitles.push("Birthday Wishes");
              }
            }
            // Handle Happy Anniversary logic
            else if (
              item?.subfeature === "Happy Anniversary" &&
              props?.isAnniDay
            ) {
              if (!carouselTitles.includes("Happy Anniversary")) {
                carouselTitles.push("Happy Anniversary");
              }
            } else if (
              item?.subfeature === "My Schedule" &&
              (props?.classRosterAndRequestId?.ClassRosterId === "14685" ||
                props?.classRosterAndRequestId?.ClassRosterId === "14686" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15555" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15556" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15557" ||
                props?.classRosterAndRequestId?.ClassRosterId === "18700" ||
                props?.classRosterAndRequestId?.ClassRosterId === "18822" ||
                props?.classRosterAndRequestId?.ClassRosterId === "17104" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20126" ||
                props?.classRosterAndRequestId?.ClassRosterId === "15940" ||
                 props?.classRosterAndRequestId?.ClassRosterId === "145" ||
               props?.classRosterAndRequestId?.ClassRosterId === "20132" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20161" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20217" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20218" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20851" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20850" ||
                props?.classRosterAndRequestId?.ClassRosterId === "20852")
            ) {
              if (!carouselTitles.includes("My Schedule")) {
                carouselTitles.push("My Schedule");
              }
            } else if (
              !["Birthday Wishes", "Happy Anniversary"].includes(
                item?.subfeature
              )
            ) {
              if (!carouselTitles.includes(item?.subfeature)) {
                carouselTitles.push(item?.subfeature);
              }
            }

            return GetBanner(
              item?.subfeature,
              props,
              key,
              countryName,
              item?.web_url,
              item?.mobile_url,
              item?.is_sso,
              item?.is_url,
              item?.url,
              item?.display_text
            );
          })}
      </Slider>

      <div className="playPauseBtnContainer">
        {playBtnVisibility === true ? (
          <button className="button playPauseBtn" onClick={pauseSlider}>
            <FontAwesomeIcon icon={faPause} className="playPauseBtnIcon" />
          </button>
        ) : (
          <button className="button playPauseBtn" onClick={playSlider}>
            <FontAwesomeIcon icon={faPlay} className="playPauseBtnIcon" />
          </button>
        )}
      </div>

      <Dialog
        header="Your Pay Matters"
        visible={visible}
        style={{ width: "60vw" }}
        onHide={() => {
          setVisible(false);
        }}
        footer={footerContent}
      >
        <DialogBox></DialogBox>
      </Dialog>

      <Dialog
        visible={props.displayBasic}
        onHide={() => onHide("displayBasic")}
        className="displayBasicDialog"
      >
        <iframe
          title="welcome video"
          width="100%"
          height="100%"
          src="https://ttecvideos.wistia.com/medias/3tujppqoju"
        ></iframe>
      </Dialog>
    </>
  );
}
